
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import { ClassMap } from '../configuration/ElementConfiguration';

@Component({
  name: 'Organization',
  components: {},
})
export default class Organization extends ElementBase {
  private organization: string | null = null;

  constructor() {
    super();
    this.lastDataUpdate = new Date(0);
    this.timeoutSeconds = 120;
  }

  private get title(): string {
    return this.organization ?? '---';
  }

  async mounted(): Promise<void> {
    await super.mounted();
    this.enableTimeout();
  }

  beforeDestroy(): void {
    super.beforeDestroy();
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);

    if (elementPath !== this.elementPath) {
      return;
    }

    const update = JSON.parse(json);
    Object.entries(update).forEach(([key, value]) => {
      if (key === 'organization') {
        this.organization = value as string;
        this.lastDataUpdate = new Date();
      }
    });
  }

  protected defaultClass(): ClassMap {
    return Object.assign({}, super.defaultClass(), { 'd-inline-block': true });
  }
}
